import axios from 'axios';
const url = process.env.VUE_APP_BACKEND_URL
export default {
    getHolidays() {
        return axios.get(url + 'get-holidays/').then(response => response.data);
    },
    addHoliday(name, start, end) {
        return axios.post(url + 'holidays/add/', {name, start, end}).then(response => response.data);
    },
    editHoliday(id, name, start, end) {
        return axios.post(url + 'holidays/edit/', {id, name, start, end}).then(response => response.data)
    },
};
